import {
    liveCheckActions,
    liveCheckSelectors,
} from 'wanderu-ducks-live-check';
import { tripActions } from 'wanderu-ducks-trips';

function removeLiveChecksForTripId(tripId) {
    return (dispatch, getState) => {
        const liveChecks = liveCheckSelectors.selectLiveChecks(getState());
        const lcIds = Object.keys(liveChecks).filter((id) => id.includes(tripId));

        lcIds.forEach((lcId) => {
            dispatch(liveCheckActions.removeTripLiveChecks(lcId));
        });
    };
}

function removeTripsWithId(tripId) {
    return (dispatch, getState) => {
        dispatch(tripActions.removeTrip(tripId));
        dispatch(removeLiveChecksForTripId(tripId));
    };
}

export {
    removeTripsWithId,
};
